import { ClosureDto } from './closure-dto';
import { PackagingComponentEntryDto } from './packaging-component-entry-dto';

export class ClosureEntryDto extends PackagingComponentEntryDto {
    removedBeforeUsage: boolean | null = null;
    removedByConsumer: boolean | null = null;
    separationThroughCollectionAndSorting: boolean | null = null;
    underlyingComponent!: ClosureDto;
}
